import { Alert, Button, Checkbox, Dialog, FormControlLabel, FormGroup, Grid2, Snackbar, TextField } from "@mui/material";
import { Box, Fab } from "@mui/material";
import ReplyRoundedIcon from "@mui/icons-material/ReplyRounded";
import { useEffect, useState } from "react";
import axios from "axios";
import imageCompression from "browser-image-compression";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


function AdminEdu() {
    const [duvidas, setDuvidas] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null);
    const [showAddForm, setShowAddForm] = useState(false);
    const [errorText, setErrorText] = useState('');
    const [successText, setSuccessText] = useState('');
    const [error, setError] = useState(false);
    const [open, setOpen] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [titulo, setTitulo] = useState('');
    const [resposta, setResposta] = useState('');

    const handleClickDialog = () => {
        setOpenDialog(true);
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setError(false);
        setOpenDialog(false);
        setOpen(false);
    };

    const fetchDuvidas = async () => {
        try {
            const response = await axios.get(`https://api.sigmasystems.com.br/api/odontoluzzi/get-duvida`);
            setDuvidas([...response.data]);        
        } catch (error) {
            console.error("Erro na requisição:", error);
        }
    };

    useEffect(() => {
        fetchDuvidas();
    }, []);

    const handleOpenAdd = () => {
        setSelectedCard(null);
        setShowAddForm(true);
        setTitulo('');
        setResposta('');
    }
    const handleSelectCard = (duvida) => {
        if (showAddForm) {
            setShowAddForm(false)
        }
        if (selectedCard?.id === duvida.id) {
            handleCancel();
        } else {
            setSelectedCard(duvida)
            setTitulo(duvida.titulo);
            setResposta(duvida.resposta);
        }
    }
    const handleCancel = () => {
        setSelectedCard(null);
        if(showAddForm) {
          setShowAddForm(false);
        }
        setTitulo('');
        setResposta('');
    };

    const handleSave = async () => {
        try {
            const data = {id:selectedCard.id, titulo:titulo, resposta:resposta};
            await axios.post('https://api.sigmasystems.com.br/api/odontoluzzi/edit-duvida', data);
            setOpen(true);
            setSuccessText('Duvida Alterada!');
            
            handleCancel();
            await fetchDuvidas();

        } catch(error) {
            setError(true);
            setErrorText('Erro ao alterar Duvida!')
            console.error("Erro ao salvar Duvida:", error);
        }
    }
    const handleAdd = async () => {
        if (!titulo || !resposta){
            setError(true);
            setErrorText('Verifique os campos!')
            return error;
          }
        try {
            const data = {titulo:titulo, resposta:resposta};
            await axios.post('https://api.sigmasystems.com.br/api/odontoluzzi/duvida-register', data);
            setOpen(true);
            setSuccessText('Duvida Cadastrada!');
            handleCancel();
            await fetchDuvidas();
        } catch (error) {
            setError(true);
            setErrorText('Erro ao adicionar Duvida');
            console.error("Erro ao salvar Duvida:", error);
        }
    }
    const handleExcluir = async () => {
        try {
          const id = selectedCard.id;
          await axios.post(
            'https://api.sigmasystems.com.br/api/odontoluzzi/remove-duvida',
            {id:id},        
          );
    
          setOpen(true);
          setOpenDialog(false);
          setSelectedCard(null);
          fetchDuvidas();
          setSuccessText('Serviço excluído!')
        } catch (error) {
          setError(true);
          setErrorText('Erro ao excluir serviço!')
        }
    }

    return(
    <div className="container">
        <div className="body" style={{ justifyItems: "center", width: "100%" }}>
            <div className="adminMenuContainer">
                <div className="adminTitle">Educacional</div>
                <div
                className="adminMenuContent"
                style={{
                    maxWidth: "1280px",
                    height: "fit-content",
                    maxHeight:'700px',
                    borderRadius: "0px 0px 10px 10px",
                }}
                >
                    <Grid2 container spacing={2}>
                        <Grid2 item>
                            <Button
                            onClick={handleOpenAdd}
                            sx={{
                                color: "#fff",
                                height: 40,
                                width: 162,
                                borderRadius: "5px",
                                fontSize: "18px",
                                backgroundColor: "#B08E44",
                                textTransform: "none",
                                "&:hover": { color: "#fff", backgroundColor: "#041819" },
                            }}
                            >
                            + ADICIONAR
                            </Button>
                        </Grid2>
                        <Grid2 item>
                            <Button
                            disabled={!selectedCard}
                            onClick={handleClickDialog}
                            sx={{
                                color: "#B08E44",
                                height: 40,
                                width: 162,
                                borderRadius: "5px",
                                fontSize: "18px",
                                backgroundColor: "none",
                                border: selectedCard ? "solid 2px #B08E44" : 'solid 2px #cfcfcf',
                                "&:hover": { color: "#fff", backgroundColor: "#041819" },
                            }}
                            >
                            EXCLUIR
                            </Button>
                        </Grid2>
                    </Grid2>
                    <div className="adminSubTitle">Lista de Duvidas</div>
                    <Grid2 container spacing={2}>
                    {duvidas.map((duvida) => (
                        <Grid2 item key={duvida.id}>
                        <Button
                            sx={{
                            color:
                                selectedCard?.id === duvida.id
                                ? "#fff"
                                : "#B08E44",
                            border:
                                selectedCard?.id === duvida.id
                                ? "none"
                                : "2px solid #B08E44",
                            backgroundColor:
                                selectedCard?.id === duvida.id ? "#B08E44" : "#fff",
                            "&:hover": {
                                backgroundColor: "#041819",
                                color: "#fff",
                            },
                            }}
                            variant={
                            selectedCard?.id === duvida.id
                                ? "contained"
                                : "outlined"
                            }
                            onClick={() => handleSelectCard(duvida)}
                        >
                            {duvida.titulo}
                        </Button>
                        </Grid2>
                    ))}
                    </Grid2>
                    {showAddForm && (
                        <div>
                            <div className="adminSubTitle">Título</div>
                            <TextField
                            fullWidth
                            variant="outlined"
                            value={titulo}
                            onChange={(e) => {setTitulo(e.target.value)}}
                            />

                            <div className="adminSubTitle">Resposta</div>
                            <TextField
                            fullWidth
                            multiline
                            variant="outlined"
                            value={resposta}
                            onChange={(e) => {setResposta(e.target.value)}}
                            />
                            <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
                                <Grid2 item>
                                    <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "#B08E44",
                                        "&:hover": { backgroundColor: "#041819" },
                                    }}
                                    onClick={handleAdd}
                                    >
                                    Finalizar
                                    </Button>
                                </Grid2>
                                <Grid2 item>
                                    <Button
                                    variant="outlined"
                                    sx={{ border: "2px solid #B08E44", color: "#B08E44" }}
                                    onClick={handleCancel}
                                    >
                                    Cancelar
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </div>
                    )}
                    {selectedCard && (
                    <div>
                        <div className="adminSubTitle">Título</div>
                        <TextField
                        fullWidth
                        variant="outlined"
                        value={titulo}
                        onChange={(e) => {setTitulo(e.target.value)}}
                        />

                        <div className="adminSubTitle">Resposta</div>
                        <TextField
                        fullWidth
                        multiline
                        variant="outlined"
                        value={resposta}
                        onChange={(e) => {setResposta(e.target.value)}}
                        />
                    
                        <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid2 item>
                                <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#B08E44",
                                    "&:hover": { backgroundColor: "#041819" },
                                }}
                                onClick={handleSave}
                                >
                                Finalizar
                                </Button>
                            </Grid2>
                            <Grid2 item>
                                <Button
                                variant="outlined"
                                sx={{ border: "2px solid #B08E44", color: "#B08E44" }}
                                onClick={handleCancel}
                                >
                                Cancelar
                                </Button>
                            </Grid2>
                        </Grid2>
                    </div>
                    )}
                </div>
                <Box
                    sx={{
                    "& > :not(style)": { m: 1 },
                    position: "absolute",
                    bottom: 16,
                    right: 16,
                    }}
                >
                    <Fab
                    onClick={() => window.history.back()}
                    variant="extended"
                    sx={{
                        backgroundColor: "#B08E44",
                        color: "#fff",
                        "&:hover": { backgroundColor: "#041819" },
                    }}
                    >
                    <ReplyRoundedIcon sx={{ mr: 1 }} /> Voltar
                    </Fab>
                </Box>
            </div>
        </div>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
          <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
          >
          {successText}
          </Alert>
      </Snackbar>
      <Snackbar open={error} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
          <Alert
          onClose={handleClose}
          severity="error"
          variant="filled"
          sx={{ width: '100%' }}
          >
          {errorText}
          </Alert>
      </Snackbar>
      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Tem certeza que deseja excluir a dúvida?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            "{titulo}"
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleExcluir} autoFocus>
            EXCLUIR
          </Button>
        </DialogActions>
      </Dialog>
    </div>
    )
}
export default AdminEdu;